'use-strict';

/**
 * Manages communications with Companion
 */
var RequestClient = require('./RequestClient');
var Provider = require('./Provider');
var Socket = require('./Socket');
module.exports = {
  RequestClient: RequestClient,
  Provider: Provider,
  Socket: Socket
};